import { render, staticRenderFns } from "./ControlSidebarComponent.vue?vue&type=template&id=00252d94&"
import script from "./ControlSidebarComponent.vue?vue&type=script&lang=js&"
export * from "./ControlSidebarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00252d94')) {
      api.createRecord('00252d94', component.options)
    } else {
      api.reload('00252d94', component.options)
    }
    module.hot.accept("./ControlSidebarComponent.vue?vue&type=template&id=00252d94&", function () {
      api.rerender('00252d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/components/ControlSidebarComponent.vue"
export default component.exports